import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

import Select from '../Select/Select'

import * as Styled from '../styles'
import { useAppSelector } from '../../hooks'

const ASSEMBLY_ID = 'assembly'

const formatValue = (value: string | number): string => `${(+value / 1000).toFixed(1).toString().replace('.', ',')} m`

const SizePanel: React.FC = () => {
  const configurator = useConfiguratorContext()

  const {
    meta: { buildingArea },
    props: { width, length },
  } = useAppSelector((state) => state.configResult) as any
  const { content } = useAppSelector((state) => state.init)

  return (
    <Styled.Panel>
      {/* TODO--låg-prio upprepningar */}
      <Select
        id="width"
        value={width.value}
        onChange={(event: any) => {
          configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
            width: +event.target.value,
          })
        }}
        options={width.options.flatMap((option: any) =>
          option.available ? [{ key: option.value, value: option.value, disabled: false }] : []
        )}
        formatterForOption={formatValue}
        label={content?.props?.width?.title}
      />
      <Select
        id="length"
        value={length.value}
        onChange={(event: any) => {
          configurator.updateItem(ASSEMBLY_ID, ASSEMBLY_ID, {
            length: +event.target.value,
          })
        }}
        options={length.options.flatMap((option: any) =>
          option.available ? [{ key: option.value, value: option.value, disabled: false }] : []
        )}
        formatterForOption={formatValue}
        label={content?.props?.length?.title}
      />
      <span>
        {content?.meta?.buildingArea?.title}: <strong>{buildingArea.toString().replace('.', ',')} m²</strong>
      </span>
    </Styled.Panel>
  )
}

export default SizePanel
